var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_area containerBox"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Pavilionlayout')))]),_c('div',{staticClass:"list"},[_c('al-image',{staticClass:"img",attrs:{"src":_vm.img,"fit":"fill"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }